// Titelbilder liegen ausschließlich an den Artikeln (`articles.image_id`). Ein Kapitel
// zeigt das Bild seines ersten Artikels - dafür holt jede Kapitel-Query zusätzlich das
// `cover`-Feld. Der Alias ist nötig, weil viele Queries `articles` schon in voller Länge
// selektieren (Artikelzahl, Slugs) und `limit: 1` das kaputtmachen würde.

// Bewusst ohne `live`-Filter: Das Titelbild ist eine Eigenschaft des Kapitels, die nur
// am ersten Artikel gespeichert liegt. Wird dieser Artikel auf "Entwurf" gesetzt, soll
// das Kapitelbild bleiben - sonst wechselt oder verschwindet es beim Umschalten. Das
// Titelbild-Feld im CMS (GET_CHAPTER_FIRST_ARTICLE) bearbeitet ebenfalls immer den
// ersten Artikel, unabhängig von `live`; beide Seiten müssen denselben Artikel meinen.

/**
 * Dieselbe Form, die das Fragment `ChapterCoverFields` liefert. Die Felder sind optional,
 * weil `articles.image_id` und `.image_alt` im Schema nullable sind und der Codegen sie
 * deshalb als optional ausgibt - sonst passte kein Abfrageergebnis in diesen Typ.
 */
export type ChapterCoverArticle = {
  image_id?: string | null
  image_alt?: string | null
}

export type WithChapterCover = {
  cover?: ChapterCoverArticle[] | null
}

export function chapterCoverImageId(chapter?: WithChapterCover | null): string | null {
  return chapter?.cover?.[0]?.image_id ?? null
}

export function chapterCoverAlt(chapter?: WithChapterCover | null): string | null {
  return chapter?.cover?.[0]?.image_alt ?? null
}
